import gql from 'graphql-tag';

import jobCopyIntegrationItemFragment from '../fragments/jobCopyIntegrationItemFragment';

export const mutationCreateJobMoveIntegrationItem = gql`
  mutation createJobMoveIntegrationItem(
    $integrationID: DokkioID!
    $remoteID: ID!
    $newIntegrationID: DokkioID!
    $newParentRemoteID: ID!
    $newSlackChannelRemoteID: ID
  ) {
      createJobMoveIntegrationItem(
        integrationID: $integrationID
        remoteID: $remoteID
        newIntegrationID: $newIntegrationID
        newParentRemoteID: $newParentRemoteID
        newSlackChannelRemoteID: $newSlackChannelRemoteID
      ) {
        ...jobCopyIntegrationItemFragment
      }
  }
  ${jobCopyIntegrationItemFragment}
`;

export default mutationCreateJobMoveIntegrationItem;
